import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Crown, Trophy, Medal, UserPlus } from "@phosphor-icons/react";
import api, { apiErr } from "../api";
import { brandIconSquare } from "../brand";

export default function PublicProfile() {
  const { userId } = useParams();
  const nav = useNavigate();
  const [p, setP] = useState(undefined);
  const [following, setFollowing] = useState(false);
  const loggedIn = !!localStorage.getItem("ff_token");
  useEffect(() => { api.get(`/leaderboards/profile/${userId}`).then((r) => setP(r.data)).catch(() => setP(null)); }, [userId]);

  const follow = async () => {
    try { await api.post("/rivals/follow", { rival_id: userId }); setFollowing(true); toast.success("Rival followed"); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div className="min-h-screen bg-ff-bg px-4 py-6 text-ff-parchment">
      <div className="mx-auto max-w-2xl">
        <button onClick={() => nav("/leaderboards")} className="mb-4 flex items-center gap-1 text-sm text-ff-muted hover:text-ff-gold" data-testid="profile-back">
          <ArrowLeft size={16} /> Back to leaderboards
        </button>
        {p === undefined ? <div className="py-20 text-center text-ff-muted">Loading...</div> : p === null ? (
          <div className="ff-panel rounded-md p-10 text-center text-ff-muted">This explorer's profile is private.</div>
        ) : (
          <div className="ff-panel rounded-md p-8" data-testid="public-profile">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <img src={brandIconSquare} alt="Aurumward emblem" className="h-16 w-16 rounded-lg object-cover" />
                <div>
                  <h1 className="font-display text-3xl font-bold text-ff-parchment">{p.username}</h1>
                  <div className="flex items-center gap-2 text-sm text-ff-brass"><Crown size={15} /> {p.rank}{p.public_title ? ` · ${p.public_title}` : ""}</div>
                </div>
              </div>
              {loggedIn && (
                <button onClick={follow} disabled={following} data-testid="profile-follow-btn"
                  className="flex items-center gap-1.5 rounded-sm bg-ff-gold px-3 py-2 text-sm font-semibold text-ff-bg transition-colors hover:bg-ff-brass disabled:opacity-50">
                  <UserPlus size={16} weight="bold" /> {following ? "Following" : "Follow Rival"}
                </button>
              )}
            </div>
            <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
              <Stat icon={Trophy} label="Frontier Score" value={p.frontier_score} />
              <Stat icon={Medal} label="Reputation" value={p.reputation} />
              <Stat label="Mastery" value={p.mastery_score} />
              <Stat label="Successful" value={p.successful} />
            </div>
            {p.pinned_achievements?.length > 0 && (
              <div className="mt-5">
                <div className="mb-2 text-xs uppercase tracking-wide text-ff-muted">Pinned Achievements</div>
                <div className="flex flex-wrap gap-2">
                  {p.pinned_achievements.map((a) => <span key={a} className="rounded-sm border border-ff-gold/40 px-2 py-1 text-xs text-ff-gold">{a}</span>)}
                </div>
              </div>
            )}
            {p.region && <div className="mt-4 text-xs text-ff-muted">Region: {p.region}</div>}
          </div>
        )}
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-sm bg-ff-bg/40 p-3 text-center">
      {Icon && <Icon size={18} weight="duotone" className="mx-auto mb-1 text-ff-gold" />}
      <div className="font-mono-ff text-xl font-bold text-ff-parchment">{value ?? "-"}</div>
      <div className="text-[10px] uppercase tracking-wide text-ff-muted">{label}</div>
    </div>
  );
}
